export const SUBMIT = 'SUBMIT';
export const CLEAR = 'CLEAR';

export const OVERWRITE_FORM = 'OVERWRITE_FORM';

export const overwriteFormAction = payload => ({
  type: OVERWRITE_FORM,
  payload,
});

const submitAction = (payload, formName, stepName) => ({
  type: `SUBMIT${formName ? `_${formName}` : ''}${stepName ? `_${stepName}` : ''}`,
  payload,
});

export const submit = (payload, formName, stepName) => (dispatch) => {
  if ((formName && formName.includes('_')) || (stepName && stepName.includes('_'))) {
    throw new Error('formName or stepName cannot contain "_"');
  }

  return dispatch(submitAction(payload, formName, stepName));
};

const clearAction = (payload, formName, stepName) => ({
  type: `CLEAR${formName ? `_${formName}` : ''}${stepName ? `_${stepName}` : ''}`,
  payload,
});

export const clear = (payload, formName, stepName) => (dispatch) => {
  if ((formName && formName.includes('_')) || (stepName && stepName.includes('_'))) {
    throw new Error('formName or stepName cannot contain "_"');
  }

  return dispatch(clearAction(payload, formName, stepName));
};
